export { default } from "./InventoryPreview";
